<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <v-row no-gutters>
    <v-col v-if="!foldersModeActive && results.count > 0" cols="2" class="py-6 pr-6">
      <v-card
        id="toGet"
        class="px-3 py-2"
        elevation="0"
        style="height: calc(100vh - 112px); overflow-x: none; overflow-y: auto;"
        color="secondary"
        tile
      >
        <v-card-text class="px-1 py-0">
          <v-row class="mt-3 px-3" align="center">
            <v-chip class="ma-1" small color="#A0A0A0" @click="clearSearch()">Tout effacer</v-chip>
            <v-spacer />
            <v-btn v-if="isExportableToExcel" icon @click="openExportExcelDialog">
              <v-icon dark>import_export</v-icon>
            </v-btn>
          </v-row>
        </v-card-text>
        <transition-group
          v-for="facet in facetsWidgets"
          :key="facet.facetKey"
          name="list"
          tag="p"
        >
          <div :key="facet.facetKey">
            <FacetRefinementList
              v-if="facet.facetType === 'refinement-list'"
              v-bind="facet.facetSettings"
              :records-query="query"
              :values="(results.facets && results.facets[facet.facetKey]) ? results.facets[facet.facetKey] : {}"
              :attribute="facet.facetKey"
              :filter-toggle="toggleFilter"
              :selected-filters="filtersSelected"
              :is-raw="isRaw"
            />
            <FacetRangeSlider
              v-else-if="'range-slider'"
              :values="results.facets[facet.facetKey]"
              :facet="facet"
              :range-change="changeRanges"
              :selected-min="rangeSelected[facet.facetKey] ? rangeSelected[facet.facetKey].min : null"
            />
          </div>
        </transition-group>

        <!-- <transition-group
          v-for="facet in facetsWidgets"
          :key="facet.facetKey"
          name="list"
          tag="p"
        >
          {{ facet.facetKey }}
           <div v-if="f.facetSettings && f.facetSettings.configs && f.facetSettings.configs.facetType" :key="facetKey">
          <div :key="facet.facetKey">
            <!  <FacetRefinementList
              v-if="facet.facetType === 'refinement-list'"
              v-bind="facet.facetSettings"
              :values="facet.facetValue"
              :attribute="facet.facetKey"
            />
           <FacetRangeSlider v-else-if="'range-slider'" :facet="facet" />
          </div>
          <- <component :is="'facet-' + facet.facetType" v-bind="facet.facetSettings"
            v-if="facet.facetType !== 'range-slider'" :state="state" :facet="facet" :attribute="f.facetKey" /> -->
        <!-- <ais-panel v-for="facet in getFacets(content)" :key="facet.attribute">
            <div class="filter-title">{{ facet.label }}</div>
      <component
        :is="'ais-'+facet.facetType"
        v-if="facet.facetType !== 'range-slider'"
        :name="facet.attribute"
        :class-names="classNames('ais-'+facet.facetType)"
        :attribute="facet.attribute"
        v-bind="facet.facetSettings"
      />
      <ais-range-input v-else :attribute="facet.attribute">
        <div slot-scope="{ currentRefinement, range, refine }">
          <vue-slider
            class="px-2"
            :min="facet.min"
            :max="facet.max"
            :lazy="true"
            :value="toValue(currentRefinement, range)"
            v-bind="facet.facetSettings"
            @change="refine({ min: $event[0], max: $event[1] })"
          />
        </div>
      </ais-range-input>
      </ais-panel> -
        </transition-group>
        </transition-group> -->
      </v-card>
    </v-col>

    <v-col>
      <v-row class="align-center py-4">
        <template v-if="foldersModeActive">
          <Breadcrumbs :path="currentPath" :open-folder="openFolder" />
          <v-spacer />
          <ContentButton v-if="$store.getters.permissionToWrite" :get-dir="currentPath" />
        </template>
      </v-row>

      <v-row v-show="!foldersModeActive && results.count > 0" class="pl-5">
        <v-col class="px-0 py-2">
          <span v-show="results.count > 0" class="my-2 text-body-2">{{ results.count }} results</span>
          <FacetCurrentRefinements
            :filter-toggle="toggleFilter"
            :range-change="changeRanges"
            :selected-filters="filtersSelected"
            :facets="facetsWidgets"
            :selected-ranges="rangeSelected"
            class="pl-5"
          />
        </v-col>
      </v-row>
      <v-row ref="searchTable" no-gutters>
        <InfoTable
          :sort-by.sync="sortBySync"
          :sort-desc.sync="sortDescSync"
          :use-custom-sort="true"
          :items="results.items"
          :count="results.count"
          :is-last-page="false"
          :show-more="showMore"
          :action="edit"
          :folders-mode-active="foldersModeActive"
          :hide-common-headers="false"
          :custom-headers="getCustomHeaders(selectedContentType)"
          :loading="loadingSearch"
          :pagination="pagination"
        />
      </v-row>
    </v-col>

    <ExportToExcel
      :all-search-variables="searchVariables"
      :dialog="exportToExcelDialog"
      :close="() => { exportToExcelDialog = false }"
    />
    <!-- </v-card>
    </v-col> -->
  </v-row>
</template>

<script setup>
import Vue, { computed, nextTick, ref, set, watch, onMounted, onUnmounted, onActivated, onDeactivated } from 'vue';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import { useStore } from 'vue2-helpers/vuex';
import { useQuery } from '@vue/apollo-composable';

import FacetRefinementList from '@/components/search/FacetRefinementList.vue';
import FacetRangeSlider from '@/components/search/FacetRangeSlider.vue';
import FacetCurrentRefinements from '@/components/search/FacetsCurrentRefinements.vue';

import InfoTable from '@/components/search/InfoTable.vue';
import Breadcrumbs from '@/components/contents/Breadcrumbs.vue';
import ContentButton from '@/components/contents/ContentButton.vue';
import ExportToExcel from '../components/editor/ExportToExcel.vue';

import { getGraphqlSchema } from '../graphql/index';
import { editContent, getContentType, getCustomHeaders, getFacets } from '@/utils/content';

const route = useRoute();
const router = useRouter();

const store = useStore();

/* Redirect to search if user as restrictions  */
const currentUser = computed(() => store.state.currentUser);

if (currentUser.value && router.history.current.name === 'home' && store.state.environment.PROJECT !== 'alpha') {
  if (currentUser.value.restrictions.length && currentUser.value.restrictions.find(r => r.type === 'show_only_content_types' || r.type === 'show_only_contents')) {
    router.push('/search');
  }
}
/* ################ */

const results = ref({
  count: 0,
  items: [],
  facets: {}
});

const start = ref(0);

const limit = computed(() => {
  const pageHeight = window.innerHeight;

  // 184 => height since the top of the page until the table
  // 48 => each row of the table
  const numberOfItems = Math.ceil((pageHeight - 184) / 48);
  return numberOfItems > 20 ? numberOfItems : 20;
});

const pagination = computed(() => ({
  currentPage: (start.value / limit.value + 1),
  totalPages: Math.ceil(results.value.count / limit.value)
}));

const filtersSelected = ref({});

const rangeSelected = ref({});

const exportToExcelDialog = ref(false);

const foldersModeActive = computed(() => route.meta && route.meta.folderRoute);

const clearResults = () => {
  console.log('clearResults');

  start.value = 0;
  results.value.items = [];
};

const query = computed({
  get () {
    return route.params.searchText || '';
  }
});

const currentPath = computed(() => route.params.pathMatch || '/');

onMounted(() => {
  console.log('Mounted');
});

onUnmounted(() => {
  console.log('onUnmounted');
});

onActivated(() => {
  console.log('onActivated');
});

onDeactivated(() => {
  console.log('onDeactivated');
});

const selectedContentType = computed(() => {
  if (filtersSelected.value.wtype && filtersSelected.value.wtype.length) {
    return getContentType(filtersSelected.value.wtype[0], store.state.rawContentTypes);
  }

  return null;
});

const isExportableToExcel = computed(() => {
  if (!selectedContentType.value?.configs?.wtype) return false;

  const { exportableContentTypes } = store.getters.workspace.settings;

  return exportableContentTypes ? exportableContentTypes.includes(selectedContentType.value.configs.wtype) : true;
});

const facetsFromContentType = computed(() => {
  if (selectedContentType.value) {
    return getFacets(selectedContentType.value);
  }

  return [];
});

const facetsWidgets = computed(() => {
  const listOfFacets = [];

  listOfFacets.push({
    facetKey: 'wtype',
    facetType: 'refinement-list',
    facetOrder: 0,
    facetSettings: {
      'single-select': true,
      limit: 10,
      operator: 'or',
      showMore: true,
      'sort-by': [
        'count:desc'
      ]
    }
  });

  facetsFromContentType.value.forEach(facet => {
    if (facet.attribute === 'wtype') {
      return;
    }

    listOfFacets.push({
      facetKey: facet.attribute,
      ...facet,
      facetName: facet.facetSettings && facet.facetSettings.searchable ? facet.attribute : `${facet.attribute}.raw`,
      facetOrder: facet.order || 0
    });
  });

  return listOfFacets.sort((a, b) => {
    const leftValue = a.facetOrder || 0;
    const rightValue = b.facetOrder || 0;

    if (leftValue < rightValue) {
      return -1;
    }

    if (leftValue > rightValue) {
      return 1;
    }

    return 0;
  });
});

const isRaw = key => !!facetsWidgets.value.find(f => f.facetKey === key && f.facetSettings && f.facetSettings.searchable);

// Wildcard expression (*) used on fields to search on all fields with a specific prefix
let fieldsToSearch = store.state.searchFields;

if (store.getters.workspace.settings.navBarSearchFields) {
  fieldsToSearch = fieldsToSearch.concat(store.getters.workspace.settings.navBarSearchFields);
}

const sortBy = ref('wtitle.raw');
const sortBySync = computed({
  get () {
    return sortBy.value;
  },
  async set (value) {
    await nextTick();
    clearResults();
    sortBy.value = value;
  }
});

const sortDesc = ref(false);
const sortDescSync = computed({
  get () {
    return sortDesc.value;
  },
  async set (value) {
    await nextTick();
    clearResults();
    sortDesc.value = value;
  }
});

const clearSearch = () => {
  console.log('clearSearch');
  filtersSelected.value = {};
  rangeSelected.value = {};

  sortBy.value = 'wtitle.raw';
  sortDesc.value = false;

  if (start.value !== 0) {
    start.value = 0;
    results.value = {
      count: 0,
      items: [],
      facets: {}
    };
  }
};

const searchVariables = computed(() => {
  console.log('************ searchVariables ****************+');
  const filter = [{
    terms: {
      workspace: [
        store.getters.workspace.code
      ]
    }
  }];

  console.log('search variables changed values', currentPath.value, query.value);

  let aggregations = null;

  if (foldersModeActive.value) {
    filter.push({
      terms: {
        'path.raw': [
          currentPath.value
        ]
      }
    });
  } else {
    aggregations = {
      'wtype|Content-Types': {
        filter: {
          bool: {
            filter: [],
            should: [],
            must: [],
            must_not: []
          }
        },
        aggs: {
          'wtype|Content-Types': {
            terms: {
              field: 'wtype',
              size: 1000,
              order: { _count: 'desc' }
            }
          }
        }
      }
    };

    if (Object.keys(filtersSelected.value).length) {
      if (filtersSelected.value && filtersSelected.value.wtype && filtersSelected.value.wtype.length) {
        filter.push({ terms: { wtype: filtersSelected.value.wtype } });
      }

      // Adds to filters the facets with range
      Object.entries(rangeSelected.value).filter(([facetKey, values]) => {
        filter.push({ range: { [facetKey]: { gte: values.min, lte: values.max } } });
      });

      // Adds filters to wtype aggregation that is not present in facetsFromContentType
      aggregations['wtype|Content-Types'].filter.bool.filter = filter.filter(f => (f.terms && Object.keys(f.terms)[0] !== 'wtype') || f.range);

      // Adds new facets if wtype is selected
      facetsFromContentType.value.forEach(facet => {
        // Build main query
        // Adds to filters the filters selected
        if (filtersSelected.value[facet.attribute]) {
          const fieldName = isRaw(facet.attribute) ? `${facet.attribute}.raw` : facet.attribute;

          const selectedValues = filtersSelected.value[facet.attribute];
          const facetedSearchConditions = [];

          if (facet.facetSettings && facet.facetSettings.nestedFacet) {
            facetedSearchConditions.push({
              nested: {
                path: facet.key,
                query: { terms: { [fieldName]: filtersSelected.value[facet.attribute] } }
              }
            });
          } else {
            facetedSearchConditions.push({ terms: { [fieldName]: selectedValues.filter(value => value !== facet.facetSettings.missing) } });
          }

          // When the facet for missing values is selected
          if (selectedValues.includes(facet.facetSettings?.missing)) {
            facetedSearchConditions.push({ bool: { must_not: [{ exists: { field: fieldName } }] } });
          }

          filter.push({ bool: { should: facetedSearchConditions } });
        }
        /* ***************** */
        const fieldName = facet.facetSettings && facet.facetSettings.searchable ? `${facet.attribute}.raw` : facet.attribute;

        // Add filter to the facets but remove itself from the filters list
        const facetFilters = filter.filter(f => (f.terms && Object.keys(f.terms)[0] !== fieldName) || (f.range && Object.keys(f.range)[0] !== fieldName));

        aggregations[`${facet.attribute}|${facet.label}`] = {
          filter: {
            bool: {
              filter: facetFilters,
              should: [],
              must: [],
              must_not: []
            }
          },
          aggs: {}
        };

        // for when the field is declared on openSearch as a "nested" type
        if (facet.facetSettings && facet.facetSettings.nestedFacet) {
          const aggsTerms = {
            field: fieldName,
            size: 100,
            order: { _count: 'desc' }
          };

          aggregations[`${facet.attribute}|${facet.label}`].aggs = {
            [`${facet.attribute}|${facet.label}`]: {
              nested: { path: facet.key },
              aggs: { [`${facet.attribute}|${facet.label}`]: { terms: aggsTerms } }
            }
          };
        } else {
          const aggsTerms = {
            field: fieldName,
            size: 100,
            order: { _count: 'desc' }
          };

          // Add null values to the aggragation/facets
          if (facet.facetSettings?.missing) {
            aggsTerms.missing = facet.facetSettings.missing;
          }

          aggregations[`${facet.attribute}|${facet.label}`].aggs = { [`${facet.attribute}|${facet.label}`]: { terms: aggsTerms } };
        }
      });
    }
  }

  // Format sorting in correct value
  const formattedSortBy = sortBy.value ? sortBy.value : 'wtitle.raw';
  const formattedSortDesc = sortDesc.value ? 'desc' : 'asc';

  const { searchRestrictionsFilters } = store.getters;

  return {
    aggregations: aggregations,
    query: {
      bool: {
        // Add restrictions to search
        must: [
          ...[{
            simple_query_string: {
              query: `${query.value}*`,
              fields: fieldsToSearch
            }
          }],
          ...searchRestrictionsFilters.query.bool.must
        ],
        // Add restrictions to search
        must_not: searchRestrictionsFilters.query.bool.must_not,
        filter: filter
      }
    },
    from: start.value,
    size: limit.value,
    sort: [
      { isFolder: 'desc' },
      { [formattedSortBy]: formattedSortDesc }
    ],
    facetQuery: {
      bool: {
        // Add restrictions to search
        must: [
          ...[{
            simple_query_string: {
              query: `${query.value}*`,
              fields: fieldsToSearch
            }
          }],
          ...searchRestrictionsFilters.query.bool.must
        ],
        must_not: searchRestrictionsFilters.query.bool.must_not,
        filter: [{
          terms: {
            'workspace.raw': [
              store.getters.workspace.code
            ]
          }
        }]
      }
    }
  };
});

watch([currentPath, query], () => {
  console.log('----------------- current path, query -------', currentPath.value, query.value);
  clearSearch();
}, { deep: true });

const { onResult, loading: loadingSearch } = useQuery(
  getGraphqlSchema('facetedSearch'),
  searchVariables,
  { enabled: true, fetchPolicy: 'no-cache' }
);

onResult(result => {
  if (result.loading) {
    return;
  }

  if (start.value > 0) {
    results.value.items = results.value.items.concat(result.data.hits.items);
  } else {
    results.value.count = result.data.hits.count;
    results.value.items = result.data.hits.items;
    results.value.facets = result.data.facets.facets;
  }
});

const openFolder = (fullPath, newTab = false) => {
  let routeFullPath = '/';

  if (fullPath !== '/') {
    routeFullPath = `/folders${fullPath}`;
  }

  if (routeFullPath !== route.fullPath) {
    if (newTab) {
      window.open(routeFullPath, '_blank');
    } else {
      router.push(routeFullPath);
    }
  }
};

const edit = (content, newTab = false) => {
  if (content.wtype === 'folder') {
    const { path, name } = content;

    let fullPath = null;

    if (path !== '/') {
      fullPath = `${path}/${name}`;
    } else {
      fullPath = `${path}${name}`;
    }

    openFolder(fullPath, newTab);
  } else {
    editContent(content, router, newTab);
  }
};

const showMore = () => {
  const newStart = start.value + limit.value;
  if (newStart < results.value.count) {
    start.value = newStart;
  }
};

/** ************
TEMP
************ */

const toggleFilter = (key, facetValue) => {
  start.value = 0;
  results.value = {
    count: 0,
    items: [],
    facets: {}
  };

  const facetWidget = facetsWidgets.value.find(fw => fw.facetKey === key);
  if (!facetWidget) throw Error('Missing facet widget');

  const isSingleSelect = !!facetWidget.facetSettings['single-select'];

  // Distinguish between singleSelects and multiSelects
  if (isSingleSelect) {
    const facetValueIsSelected = filtersSelected.value[key] && filtersSelected.value[key][0] === facetValue;

    // When is wtype we need to always clear the search
    if (key === 'wtype') {
      clearSearch();
    }

    // Remove selected facet from filters
    if (facetValueIsSelected) {
      Vue.delete(filtersSelected.value, key);
    } else { // Override the current selectedFilter
      set(filtersSelected.value, key, [facetValue]);
    }
  } else { // for Multi fields
    let indexFacetValue = -1;

    if (!filtersSelected.value[key]) {
      set(filtersSelected.value, key, []);
    } else { // Check if the facetValue was already selected to toggle it off
      indexFacetValue = filtersSelected.value[key].indexOf(facetValue);
    }

    // Remove selected facet from filters
    if (indexFacetValue >= 0) {
      filtersSelected.value[key].splice(indexFacetValue, 1);

      // Remove filter if filtersSelected with this key are empty
      if (filtersSelected.value[key].length === 0) {
        Vue.delete(filtersSelected.value, key);
      }
    } else {
      filtersSelected.value[key].push(facetValue);
    }
  }
};

const changeRanges = (key, rangeValues = null) => {
  start.value = 0;
  results.value = {
    count: 0,
    items: [],
    facets: {}
  };

  if (!rangeValues) {
    Vue.delete(rangeSelected.value, key);

    return;
  }

  if (rangeSelected.value[key]) {
    rangeSelected.value[key] = rangeValues;
  } else {
    set(rangeSelected.value, key, rangeValues);
  }
};

const openExportExcelDialog = () => {
  exportToExcelDialog.value = true;
};

</script>
